import styles from "@/components/ChatBox/index.module.scss";
import Image from "next/image";
import { getLinkTargetTab } from "@/utils/helper";

export default function ChatPopup(props) {
  const { isOpen = false, chatList = [] } = props;
  if (!isOpen) return null;

  return (
    <div className={`${styles.wrapper} fixed bottom-12 right-16 z-50`}>
      <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-lg">
        <ul className="list-none m-0 px-[18px] py-[10px] divide-y divide-gray-200">
          {chatList.map(({ fields }, index) => {
            const {
              label = "",
              url = "",
              openerType = "",
              mediaItem: image = {},
            } = fields || {};
            const imagesrc = image?.fields?.file?.url ?? "";
            return (
              <li key={index} className="liclass">
                <a
                  href={url}
                  target={getLinkTargetTab(openerType)}
                  className="flex justify-start content-center items-center gap-1 text-[#337ab7] !no-underline hover:!no-underline hover:!text-[#23527c] cursor-pointer "
                >
                  <div className="li-imageicon">
                    <Image
                      src={imagesrc}
                      alt={label}
                      width={36}
                      height={36}
                      className="h-10 w-10 image-part"
                    />
                  </div>
                  <span className="font-[helveticaRoman,Helvetica,sans-serif]">
                    {label}
                  </span>
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
